module.exports = __webpack_public_path__ + "909e18905e3be54cde81317f4aac01df.png";